import { Container, Wrap } from "./stickyWrapperStyled";

import React from "react";
import { useIntersectionObserver } from "./stickyWrapperHooks";

interface Props {
  className?: string;
  withMarginBottom?: boolean;
}

export const StickyWrapper = ({
  children,
  className,
  withMarginBottom = true,
}: React.PropsWithChildren<Props>): React.ReactElement => {
  const { containerRef, isSticky } = useIntersectionObserver();

  return (
    <Container
      ref={containerRef}
      className={className}
      withMarginBottom={withMarginBottom}
    >
      <Wrap isSticky={isSticky}>{children}</Wrap>
    </Container>
  );
};
